import axios from 'axios'
import { showNotify } from 'vant'
import { STORAGE_TOKEN_KEY, STORAGE_LANG_KEY, STORAGE_USER_INFO_KEY } from '@/stores/mutation-type'
import md5 from 'crypto-js/md5'
// import { closeWebSocket } from '@/utils/websocketService'
import { errorToast } from '@/utils/toast'
import router from '@/router'
import { useUserStore } from '@/stores'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: import.meta.env.VITE_APP_API_BASE_URL,
  timeout: 6000, // 请求超时时间
})

// 签名
function generateSignature(params, secretKey, expireTime) {
  // 1. 参数排序
  const sortedParams = Object.keys(params)
    .sort()
    .map((key) => `${key}=${params[key]}`)
    .join(':')

  // 2. 拼接固定字符串
  const baseString = `${sortedParams}bjsignature`

  // 3. 添加密钥和时间戳
  const signString = `${secretKey}${expireTime}${baseString}` //  约定的secret 和 当前时间戳 expire 和

  // console.log('signString:', signString)

  // 4. 生成 MD5 签名
  return md5(signString)
}

// 请求拦截器
function requestHandler(config) {
  const savedToken = localStorage.getItem(STORAGE_TOKEN_KEY)
  // const lang = localStorage.getItem(STORAGE_LANG_KEY)
  // const appid = JSON.parse(localStorage.getItem('initConfig')).appid
  const appid = '1'
  // POST 在data中  get在params中   console.log("config:",config);
  const expireTime = Date.now()

  // // 提取请求参数
  let params = {}
  if (config.method === 'get' && config.params) {
    params = { ...config.params }
  } else if (['post', 'put', 'patch'].includes(config.method) && config.data) {
    params = { ...config.data }
  }

  // 生成签名
  const secretKey = '78e36ersfdhjhdjf82345@#!23SD14F' // 替换为实际的密钥,可优化密钥存放方式
  const signature = generateSignature(params, secretKey, expireTime)

  // 将签名和时间戳添加到请求头
  config.headers['expire'] = expireTime // expire当前时间戳
  config.headers['sign'] = signature
  // config.headers['testUid'] = '10000000'

  // 如果 token 存在
  if (savedToken) config.headers['token'] = savedToken
  // config.headers['token'] = '5cd59d5daa4353dedbc756742483f2b7'

  // if (lang)
  config.headers['Accept-Language'] = 'pt-pt' // pt-pt  en-us  zh-cn   // 旧的时pt-BR

  if (appid) config.headers['appid'] = btoa(appid)

  config.headers['loginType'] = 'broker' // 登录类型 特使处理

  return config
}

// 异常拦截处理器 -  http请求 状态码
function errorHandler(error) {
  if (error.response) {
    const { data = {}, status, message } = error.response
    // 403 无权限
    if (status === 403) {
      // showNotify({ type: 'danger', message: (data && data.message) || message, })
      errorToast((data && data.message) || message)
    }
    // 401 未登录/未授权
    if (status === 401 && data.result && data.result.isLogin) {
      // showNotify({ type: 'danger', message: 'Authorization verification failed', })
      errorToast('Authorization verification failed 401')
      // 如果你需要直接跳转登录页面 需要后端确定
      // location.replace(loginRoutePath)
    }
    //
    if (status === 500) {
      errorToast(message || 'Request failed')
    }

    if (status === 404) {
      errorToast(message || '404 api not found')
    }

    if (status === 400) {
      errorToast(message || error.message || '400 error')
    }
  }

  if (error.code === 'ECONNABORTED' || error.message === 'timeout of 6000ms exceeded') {
    errorToast('A solicitação expirou...') //请求超时
  }

  return Promise.reject(error)
}

// Add a request interceptor
request.interceptors.request.use(requestHandler, errorHandler)

// 响应拦截器  业务级别的处理
function responseHandler(response) {
  // console.log('API responseHandler:', response)
  const { status, data } = response
  // HTTP 状态码错误
  if (status !== 200) {
    errorToast(data.msg)
    return Promise.reject(new Error(data?.msg || 'Request failed'))
  }
  if (status == 200 && data.code == 1031) {
    console.log('API responseHandler: 1031', response)
    errorToast(data.msg || '1031 error')
    // closeWebSocket()
    const userStore = useUserStore()
    userStore.handleLogout()
    // router.push({ name: 'Home' })
    return
    // return Promise.reject(new Error(data?.msg || 'Request failed'))
  }
  // 不是博主身份
  if (status == 200 && data.code == 1037) {
    // console.log('API responseHandler: 1037', response)
    // localStorage.clear()
    // localStorage.setItem('active', 0)
    // closeWebSocket()
    const userStore = useUserStore()
    userStore.handleLogout()
    // router.push({ name: 'Home' })
    return response.data
  }
  // 账号封禁
  if (status == 200 && data.code == 1038) {
    // console.log('API responseHandler: 1038', response)
    errorToast(data.msg || '1038 error')
    // closeWebSocket()
    const userStore = useUserStore()
    userStore.handleLogout()
    // router.push({ name: 'Home' })
    return
    // return Promise.reject(new Error(data?.msg || 'Request failed'))
  }
  // 只是说明接口数据没有变动 直接用缓存数据 不需要处理(数据无需加载...)
  if (status == 200 && data?.code == 304) {
    return response.data
  }
  // 失败码
  if (status == 200 && data?.code !== 1) {
    errorToast(data?.msg || 'Request failed')
    return Promise.reject(new Error(data?.msg || 'Request failed'))
  }
  // 成功码
  if (status == 200 && data?.code == 1) {
    return response.data
  }
}

// Add a response interceptor
request.interceptors.response.use(responseHandler, errorHandler)

export default request
// ... existing code ...
